const log = {
  search: {
    content: "Contenu",
    logType: "Type de log"
  }
};

export default log;
